export const i18nEventPage = {
  alarm: 'Alarme',
  alarm_and_period: 'Alarme + período de risco',
  closed_alarm: 'Alarme fechado',
  expand: 'Expandir lista',
  expand_tutorial_title: 'Apresentando Insights Visuais',
  expand_tutorial_description:
    'Sua lista de alarmes agora inclui gráficos para insights rápidos. Use "Expandir Lista" para voltar à visualização completa da lista.',
  expand_tutorial_button: 'Entendi',
  show_analytics: 'Mostrar Analytics',
  grid: {
    ack_status: 'Status de Reconhecimento',
    alarms: 'Alarmes',
    acked: 'Reconhecidos',
    new: 'Novo',
  },
  analytics: {
    bar_chart_title: 'Alarmes por período',
    day: 'Diário',
    week: 'Semanal',
    month: 'Mensal',
    year: 'Anual',
    hour: 'Por hora',
  },
  automatic_ack_info: {
    text: '<strong>{{models}} modelos</strong> estão configurados com auto-reconhecimento. <strong>{{alarms}} alarmes</strong> foram reconhecidos automaticamente no período selecionado.',
    view_models: 'Ver modelos',
    view_alarms: 'Ver Alarmes',
  },
  automatic_ack_models: {
    title: 'Modelos com auto-reconhecimento habilitado',
  },
  sections: {
    prediction_graph: 'Modelo de risco de falha',
    pump_curve: 'Curva de performance da bomba',
    sensors_graph: 'Dados dos sensores',
    analysis: 'Análise',
    history: 'Histórico',
    event_list: 'Últimos eventos {{asset}}',
    flat_line_graph: 'Linha reta',
    diagnostic: 'Diagnóstico',
    recommendation: 'Recomendações',
  },
  charts_tabs: {
    features: 'Features',
    sujidade: 'Sujidade',
    sensors: 'Sensores',
    sensor: 'Sensores',
    amoeba: 'Visualização do gráfico',
    radar: 'Visão de Radar',
    risk: 'Pontuação de Risco',
    feature: 'Feature',
  },
  status_count_panel: {
    empty_data: 'Não há dados disponíveis para filtrar',
    total: { caption: 'Alarmes' },
    severity: {
      title: 'Severidade',
      4: 'Muito Alta',
      3: 'Alta',
      2: 'Média',
      1: 'Baixa',
    },
    status: {
      total: { title: 'Total', total: 'Alarmes' },
      status: {
        title: 'Status',
        OPEN: 'Novo',
        CLOSED: 'Reconhecido',
        total: 'Total por período',
      },
      classification: { title: 'Classificação', USEFUL: 'Útil', NOT_USEFUL: 'Não Útil' },
    },
  },
  event: {
    sections: {
      details: 'Detalhes',
      prognosis: 'Prognóstico',
      radar: 'Visão de radar',
      plot: 'Visualização do gráfico',
      sensors: 'Sensores',
      sensor: 'Sensores',
      risk: 'Pontuação de Risco',
    },
  },
  components: {
    alarmScalingModels: {
      tabs: { alarm_history: 'Histórico de Alarmes', scaling_models: 'Modelos de Processo' },
    },
    relatedTables: {
      events: 'Alarmes Similares',
      condition_deviations: 'Desvios de Cond.',
      sap_notes: 'Notas de Manut.',
      cases: 'Casos',
    },
    similarEvents: {
      no_data: 'Não há registro de evento semelhante reconhecido no último ano',
      text: 'Evento semelhante detectado em {{eventDate}} - {{useful}} {{eventComments}}',
      button: 'Abrir',
    },
    similarEventsList: {
      title: 'Últimas ocorrências deste alarme',
      btn: 'Alarmes Similares',
      empty_message: 'Nenhum alarme para este ativo no período selecionado.',
    },
    conditions_related: {
      viewCds: 'Ver DC do equipamento',
      newCd: 'Abrir novo DC',
      fullCdPage: 'Pág. completa de DC',
    },
    eventFooter: {
      btns: {
        maintenance: 'Manutenção',
        assetPage: 'Pág. Equip.',
        cds: 'Desv. Cond.',
        Records: 'Registros',
        ack: 'Reconhecer',
        reclassify: 'Reclassificar',
        cases: 'Casos',
      },
    },
    cdListModal: 'Desv. Cond. do Ativo',
    maintenanceModal: 'Notas de manutenção',
    modalAck: {
      title: { OPEN: 'Reconhecer este alarme', CLOSED: 'Reclassificar este alarme' },
      labels: {
        classification: 'Classificação',
        why_not_useful: 'Por que não é útil?',
        comments: 'Comentários',
        willAssociateCD: 'Deve ser tratado por um Desvio de Condição?',
        next_step: 'Próxima etapa',
        NO_ACTION: 'Sem ação',
        ATTACH_ALARM_TO_AN_EXISTING_CASE_TITLE: 'Anexar alarme a um Caso existente',
        ATTACH_ALARM_TO_AN_EXISTING_CASE:
          'Anexar alarme a um Caso existente ({{quantity}} abertos)',
        CREATE_NEW_CASE_AND_ATTACH_ALARM: 'Criar novo Caso e anexar alarme',
      },

      btns: {
        ack: 'Reconhecer',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      placeholders: {
        comments: 'Por favor, compartilhe qualquer informação relevante sobre este alarme',
        select_an_option: 'Selecione uma opção',
      },

      required_field: 'Campo obrigatório',
    },
    btns: {
      PI: 'Ir para o PI',
      Expand: 'Expandir',
    },
    event_summary: {
      start_time: 'Início',
      end_time: 'Término',
      asset_name: 'Equipamento',
      description: 'Descrição do evento',
      status: 'Status',
      classification: 'Classificação',
      model: 'Modelo',
      id: 'ID do evento',
      alarms_count: 'Alarmes',
    },
    analysis: {
      fields: {
        status: 'Status',
        classification: 'Classificação',
        action: 'Ação do operador',
        work_order: 'Ordem de serviço (número)',
        reason: 'Motivo',
        failure_occurred: 'Houve falha?',
        additional_info: 'Informações adicionais',
        end_date: 'Prazo para concluir investigação',
      },
      actions: {
        attach: 'Anexar arquivo',
        save: 'Salvar',
        attachments: 'Anexos',
        required_field: 'Campo obrigatório',
        max_length: 'Tamanho máximo de {{size}} caracteres',
      },
    },
    history: {
      comment_placeholder: 'Adicione um comentário',
      empty_history: 'Evento sem histórico de alterações',
      item: {
        template: {
          action: {
            insert: 'adicionou',
            update: 'atualizou',
            delete: 'removeu',
            attach: 'anexou',
          },
          title: '{{author}} {{action}} {{attribute}}',
          message: {
            text: '{{text}}',
            from_to: 'De {{previous}} para {{current}}',
          },
        },
      },
    },
    sensors_graphic: {
      variables_contribution: 'Contribuição por variáveis',
      all_sensors: 'Todos sensores',
      all_features: 'Todas features',
    },
    alarmsByAlgorithmTable: {
      name: 'Modelos',
      bar: 'Alarmes',
      count: '#',
      dataOptions: {
        models: 'Modelos',
        assets: 'Equip.',
      },
    },
  },
  message: {
    no_data: {
      message: 'Sem alarmes no período e filtros selecionados',
    },
    generic_error: {
      title: 'Ops..',
      message: 'Ocorreu um erro inesperado. Aguarde alguns minutos e tente novamente',
    },
    inexistent_event: {
      title: 'Evento não encontrado',
      message: 'Por favor, tente com um id de evento válido',
    },
    features_contribution_error: {
      title: 'Ops..',
      message: 'Erro ao carregar dados de contribuição por feature',
    },
    analysis_submit: {
      success: { title: 'Sucesso', message: 'Análise enviada' },
      error: { title: 'Erro', message: 'Falha ao enviar análise' },
    },
    empty_historic: {
      title: 'Histórico vazio',
      message: 'Não há atualizações para este Evento',
    },
    historic_error: {
      title: 'Erro ao carregar histórico',
      message: 'Tente novamente em alguns minutos',
    },
    comment_submit: {
      success: { title: 'Sucesso', message: 'Comentário enviado' },
      error: { title: 'Erro', message: 'Falha ao enviar comentário' },
    },
  },
  severity: {
    very_high: 'Muito Alta',
    high: 'Alta',
    medium: 'Média',
    low: 'Baixa',
    Information: 'Baixa',
    Warning: 'Baixa',
    Minor: 'Média',
    Major: 'Alta',
    Critical: 'Muito Alta',
  },
  no_data: 'Sem dados disponíveis',
  no_prognosis: 'Nenhum prognóstico disponível para este evento',
  status: {
    open: 'Aberto',
    closed: 'Fechado',
  },
  panels: {
    severity: {
      title: 'Severidade',
    },
    total: {
      caption: 'Eventos',
    },
  },
  main_tabs: {
    OPEN: 'Novos',
    CLOSED: 'Reconhecidos',
    ALL: 'Todos',
  },

  event_details: {
    severity: 'Severidade',
    alarm_datetime_start: 'Início',
    alarm_datetime_end: 'Fim',
    duration: 'Duração',
    method: 'Método',
    category: 'Categoria',
    vessel: 'Navio',
    system: 'Sistema',
    subsystem: 'Subsistema',
    asset: 'Ativo',
  },
  useful_modal: {
    withCds: {
      title: 'Alarme reconhecido. Verificar desvios de condição do ativo?',
      text: 'O alarme foi salvo como útil. Deseja verificar se há um desvio de condição aberto para investigar este problema?',
      action: 'Sim, verificar desvios de condição do ativo',
      cancelBtn: 'Não, obrigado',
    },
    withoutCds: {
      title: 'Alarme salvo. Abrir novo Desvio de Condição?',
      text: 'O alarme foi salvo como Útil. Deseja abrir um novo Desvio de Condição para investigar o problema?',
      action: 'Sim, abrir DC',
      cancelBtn: 'Não abrir',
    },
  },

  tag: {
    alarms: 'Alarmes',
    aggregated: 'Agregado',
  },
  filters: {
    all_assets: 'Todos os ativos',
    all_categories: 'Todas as categorias',
    search: 'Buscar',
  },
  table: {
    severity: 'Sever.',
    description: 'Nome',
    vessel: 'Navio',
    system: 'Sistema',
    subsystem: 'Subsistema',
    asset: 'Ativo',
    alarm_datetime_start: 'Começo',
    duration: 'Duração',
    classification: 'Classificação',
    closed_by: 'Fechado por',
    records: 'Registros',
    status: 'Status',
    agreg: '#',
    link: '',
    id: 'ID',
    checkbox: '',
    see_event: 'Ver evento',
    model_label: 'Modelo',
    case_name: 'Caso',
    number_of_alarms: 'Alarmes (periodo)',
    asset_name: 'Ativo',
  },
  change_status_form: {
    status: 'Status',
    classification: 'Classificação',
    why_not_useful: 'Por que não é útil?',
    select_an_option: 'Selecione uma opção',
    save: 'Salvar',
    required_field: 'Campo obrigatório',
  },
  expanded_charts: {
    tabs: {
      alarm_related_charts: 'Gráficos relacionados ao alarme',
      equipment_sensors: 'Sensores de equipamento',
    },
  },
  chart_status: {
    status: { OPEN: 'Aberto', CLOSED: 'Fechado' },
    classification: { USEFUL: 'Útil', NOT_USEFUL: 'Não útil' },

    whyNotUseful: {
      PROCESS_INSTABILITY: 'Instabilidade do processo',
      PRODUCTION_RESTART: 'Reinício da produção',
      INSTRUMENT_ERROR: 'Erro do instrumento',
      PROCESS_CHANGE: 'Mudança no processo',
      TESTS_IN_PROGRESS: 'Testes em andamento',
      INAPPROPRIATE_LIMITS: 'Limites inadequados',
      UNCALIBRATED_MODEL: 'Modelo não calibrado',
      THERE_IS_NO_CERTAINTY: 'Não há certeza',
      THERE_IS_NO_CERTAINITY: 'Não há certeza',
      OTHER: 'Outro',
      OTHERS: 'Outros',
      CHANGE_OF_OPERATING_LEVEL: 'Alteração do nível de operação',
      EQUIPMENT_START_STOP: 'Equipamento Inicio/parada',
      SPURIOUS_ALARM: 'Alarme espúrio',
      MACHINE_IS_OFF: 'Equipamento está desligado',
      USEFUL: 'Útil',
      NOT_USEFUL: 'Não útil',
    },
  },
  snackbarMessages: {
    success: {
      title: 'Sucesso',
      message: 'Evento atualizado com sucesso',
    },
    error: {
      title: 'Erro',
      message: 'Erro ao atualizar evento',
      upload: 'Erro ao carregar o arquivo',
      file_size: 'O arquivo é maior que o tamanho permitido',
      file_extension: 'O arquivo não está nos formatos permitidos',
    },
  },
};
